import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Accordion, Button, Card, Col, Container, Row } from "react-bootstrap";
import Nav from "./Navbar";
import Footer from "./Footer";
import serp1 from "../Images/serp1.png";
import serp2 from "../Images/serp2.png";
import tool11 from "../Images/tool11.svg";
const Serp = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    const script = document.createElement("script");
    script.type = "module";
    script.src = "/off_seo.js";
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <Container fluid className="p-0" style={{ overflowX: "hidden" }}>
      <div>
        <Nav />
      </div>

      <Row className="d-flex justify-content-center mt-4">
        <Col className="col-md-10 col-12 ">
          <div className="mx-2">
            <h1 className="m-4 text-center">
              SERP Simulator – See How Your Site Appears in Google Results
            </h1>

            <p>
              Make your first impression on Google a great one. With Seobix’s
              SERP ( search engine research page ) Simulator, you can see
              exactly how your title tag, meta description, and URL will appear
              in search results—before you ever hit publish.Your page title and
              meta description aren’t just text—they’re your invitation to
              searchers. A well-organized snippet can boost exposure, encourage
              more clicks, and enhance SEO performance in general.
            </p>
            <div className="d-flex justify-content-center">
              <img
                className="m-3"
                src={serp2}
                alt="seobix"
                style={{ width: "70vw" }}
              />
            </div>
            <h2 className="mt-3">What Makes Seobix's SERP Simulator Unique?</h2>
            <p>
              Most of the SERP preview tools just give you a rough idea. Seobix
              goes further by replicating actual Google snippets with real-time
              accuracy for both desktop and mobile. You’ll get to know exactly
              about how your page looks and how it performs before it goes live.
              Whether you’re a marketer, blogger, or small business owner, our
              SERP Simulator helps you publish with confidence. Make every
              search listing click-worthy with the clarity and tools only Seobix
              can offer.
            </p>
            <div className="d-flex justify-content-center">
              <img
                className="m-4"
                src={serp1}
                alt="seobix"
                style={{ width: "70vw" }}
              />
            </div>
            <h3>Smart Integration with Structured Data Tools</h3>
            <p>
              Seobix is unique in this regard because our simulator integrates
              with the <b>best structured data tools for small businesses</b>,
              providing you with additional information about how structured
              content impacts your search engine ranking.This implies that you
              score higher in addition to writing better.
            </p>

            <h3>Boost Clicks & Visibility</h3>
            <p className="mb-4">
              By combining SERP previewing with actionable tips, Seobix helps
              you <b>increase website traffic with structured data</b> and smarter
              optimization. Small changes in your title and description can lead
              to big jumps in traffic—and we help you get it right.
            </p>
          </div>
        </Col>
      </Row>

      <div
        className="m-0 p-0"
        style={{
          overflow: "hidden",
          background: "#31393C",
          borderTopRightRadius: "2rem",
          borderTopLeftRadius: "2rem",
        }}
      >
        <Footer />
      </div>
    </Container>
  );
};

export default Serp;
